/*
  Formwave custom: keeps the "incl. IE VAT" price line in sync when the
  displayed excl. VAT price changes (variant selection, quickshop, etc.).

  In the v1.2 theme (Empire 11) this logic was hand-edited into empire.js.
  Empire 13 ships a minified bundle, so this runs standalone instead and
  survives theme updates. Server-rendered VAT lines come from
  snippets/product-price.liquid; this script only corrects them after
  client-side price updates.
*/
(function () {
  'use strict';

  var scheduled = false;

  function parseMoney(text) {
    var cleaned = (text || '').replace(/[^\d.,]/g, '');
    if (!cleaned) return NaN;
    /* Store money format is €1,234.56 (comma thousands, dot decimal) */
    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function formatMoney(value) {
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + parts[0] + '.' + parts[1];
  }

  function syncPrice(priceRoot) {
    var rate = parseFloat(priceRoot.getAttribute('data-vat-rate'));
    if (!rate) return;

    var container = priceRoot.querySelector('[data-price-container]');
    if (!container) return;

    var priceEl = container.querySelector('[data-price]');
    if (!priceEl) return;

    var base = parseMoney(priceEl.textContent);
    if (isNaN(base)) return;

    var formatted = formatMoney(base * rate);
    var inclusiveMoney = container.querySelector('.price__vat-inclusive .money');

    if (inclusiveMoney) {
      if (inclusiveMoney.textContent.trim() !== formatted) {
        inclusiveMoney.textContent = formatted;
      }
    } else {
      /* Price was re-rendered without the VAT line; rebuild it */
      var label = container.querySelector('.price__vat-label');
      if (!label) {
        label = document.createElement('span');
        label.className = 'price__vat-label';
        label.textContent = 'excl. VAT';
        priceEl.insertAdjacentElement('afterend', label);
      }
      var line = document.createElement('div');
      line.className = 'price__vat-inclusive';
      var money = document.createElement('span');
      money.className = 'money';
      money.textContent = formatted;
      var inclLabel = document.createElement('span');
      inclLabel.className = 'price__vat-label';
      inclLabel.textContent = 'incl. IE VAT';
      line.appendChild(money);
      line.appendChild(document.createTextNode(' '));
      line.appendChild(inclLabel);
      container.appendChild(line);
    }
  }

  function syncAll() {
    scheduled = false;
    var prices = document.querySelectorAll('.price[data-vat-rate]');
    for (var i = 0; i < prices.length; i += 1) {
      syncPrice(prices[i]);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncAll);
  }

  function init() {
    syncAll();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
